import { Navigate } from "react-router";
import { useSelector } from "react-redux";

/**
 * `/verify-account` is only for the post-signup OTP step (pendingVerification.email).
 * Anyone already signed in with a session should use the main app instead.
 */
const VerifyOnlyRoute = ({ children }) => {
  const { isAuthenticated, pendingVerification } = useSelector(
    (state) => state.infoboxx_consumer,
  );

  if (pendingVerification?.email) {
    return children;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signup" replace />;
  }

  return <Navigate to="/" replace />;
};

export default VerifyOnlyRoute;
